import { render, staticRenderFns } from "./modalRelease.vue?vue&type=template&id=37aaa58d"
import script from "./modalRelease.vue?vue&type=script&lang=js"
export * from "./modalRelease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports